'use client'
import React from 'react';
import {getBreadcrumbs} from "@/components/Breadcrumbs/BreadcrumbProvider";
import {useParams} from "next/navigation";

interface Props {
    baseUrl: string;
    additionalJsonLd?: object | object[];
}

export default function BreadcrumbJsonLd({baseUrl, additionalJsonLd}: Props) {
    const breadcrumbs = getBreadcrumbs();

    // Only render if there are breadcrumbs
    if (breadcrumbs.length === 0 || (breadcrumbs.length === 1 && !breadcrumbs[0].slug)) {
        return null;
    }

    // Build the breadcrumb list items
    let currentPath = '';
    const itemListElement = breadcrumbs.map((item, index) => {
        currentPath += index > 0 ? `/${item.slug}` : `${item.slug}`;
        return {
            "@type": "ListItem",
            "position": index + 1,
            "name": item.title,
            "item": `${baseUrl}${currentPath}`
        };
    });

    const breadcrumbJsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": itemListElement
    };

    // Combine breadcrumb with additional JSON-LD objects
    let combinedJsonLd;
    if (additionalJsonLd) {
        const additionalArray = Array.isArray(additionalJsonLd) ? additionalJsonLd : [additionalJsonLd];
        combinedJsonLd = [breadcrumbJsonLd, ...additionalArray];
    } else {
        combinedJsonLd = breadcrumbJsonLd;
    }

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(combinedJsonLd)}}
        />
    );
}
